import { Button, Row } from '@rematter/ui-web';
import {
  LucideDownload,
  LucideFile,
  LucideFileText,
  LucideImage,
} from 'lucide-react';

type FileItemProps = {
  fileName: string;
  mimeType: string;
  onDownload: () => void;
};

const getFileIcon = (mimeType: string) => {
  if (mimeType === 'application/pdf') {
    return <LucideFileText className="size-5 text-failure opacity-50" />;
  }
  if (mimeType.startsWith('image/')) {
    return <LucideImage className="size-5 text-success opacity-50" />;
  }
  return <LucideFile className="size-5 text-neutral opacity-50" />;
};

//
// ⚛️ ⚛️ ⚛️ FILE ITEM ⚛️ ⚛️ ⚛️
//
export const FileItem = ({ fileName, mimeType, onDownload }: FileItemProps) => (
  <Row className="@FileItem items-center rounded-lg border border-neutral/20 bg-neutral/5 p-3">
    <div className="flex-shrink-0">{getFileIcon(mimeType)}</div>
    <span className="min-w-0 flex-1 truncate text-sm font-medium text-neutral/90">
      {fileName}
    </span>
    <Button
      variant="outline"
      size="small"
      className="p-2 text-primary/60 hover:bg-primary/5"
      onPress={onDownload}
    >
      <LucideDownload className="size-4" />
    </Button>
  </Row>
);
